import React, { useRef, useState } from "react";
import "./dropdown.css";

const Dropdown = ({ title, listItems, onSelect }) => {
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const [items, setItem] = useState(listItems);
  const [selectedItem, setSelectedItem] = useState(null);

  const onClick = () => setIsActive(!isActive);

  const handleItemClick = (id, item) => {
    selectedItem == id ? setSelectedItem(null) : setSelectedItem(id);
    setIsActive(!isActive);
    if (!!onSelect) {
      onSelect(item);
    }
  };

  return (
    <>
      {!!listItems && (
        <div className="group-dropdown ">
          <div className="styledSelect item-select" onClick={onClick}>
            {selectedItem
              ? items.find((item) => item.id == selectedItem).label
              : `${title}`}
          </div>
          <select
            ref={dropdownRef}
            className={`options ${isActive ? "active" : ""}`}
          >
            {/* <ul> */}
            {items.map((item, index) => {
              return (
                <option
                  onClick={(e) => handleItemClick(item.id, item)}
                  id={item.id}
                  key={index}
                >
                  {" "}
                  {item.label}
                </option>
              );
            })}
            {/* </ul> */}
          </select>
        </div>
      )}
    </>
  );
};

export default Dropdown;
